import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router, Params} from '@angular/router';

import {AppComponent} from './app.component';

import {AuthentificationService} from './authentification.service';
import {ProductsAbstractService} from './products-abstract.service';
import {ProductsArticleService} from './products-article.service';
import {ProductsCategoryService} from './products-category.service';
import {StocksService} from './stocks.service';

import {Lots} from './lots';
import {ProductsArticle} from './products-article';
import {ProductsCategory} from './products-category';
import {ProductsLotAbstract} from './products-lot-abstract';
import {ProductsMovementAbstract} from './products-movement-abstract';
import {SerialNumber} from './serial-number-type';

import {StockAvailibilityService} from './stock-availibility.service';

@Component({
    selector: 'app-stock-availibility',
    templateUrl: './templates/stock-availibility.component.html',
    styleUrls: ['./styles/stock-availibility.component.css'],
    providers: [ProductsCategoryService, ProductsArticleService, StocksService, ProductsAbstractService, AuthentificationService, StockAvailibilityService]
})
export class StockAvailibilityComponent implements OnInit {
    category: string;

    warehouses_list: ProductsCategory[];
    position: string = 'before';

    hide_lot_infos: boolean = false;

    stock_availibility: Object[];

    lot_abstract: ProductsLotAbstract[];
    prod_list: ProductsMovementAbstract[];

    info_article: string;

    tmp: number;
    item: string;

    movement_list: ProductsMovementAbstract[] = [];
    total: Object = {
        entree: '',
        sortie: ''
    };
    date: Object = {
        min: '',
        max: ''
    };
    //----

    ngOnInit(): void {
        this.getWarehousesList();
        this.getStockAvailibility();
    }

    constructor(
        private app_component: AppComponent,
        private router: Router,
        private stock_availibility_service: StockAvailibilityService,
        private authentification_service: AuthentificationService) {
        this.checkUserSession();

    }

    checkUserSession(): void {
        this.authentification_service.SuperUserCheckSession().then(result => {
            if (result['id_super_user'] === 0) {
                this.router.navigate(['admin'])
            } else {
                this.app_component.ShowMenu();
                this.app_component.sudo_left_menu = true;
            }
        });
    }

    changed(event: any) {
        this.prod_list = [];
        this.movement_list = [];
        this.tmp = -1;
        this.info_article = '';
        this.category = event;
        this.getStockAvailibility();
    }

    getStockAvailibility(): void {
        console.log(this.category);
        this.stock_availibility_service.getStockAvailibility(this.category)
            .then(result => {
                this.stock_availibility = result['list'];
                console.log(this.stock_availibility);
            });
    }

    getWarehousesList(): void {
        this.stock_availibility_service.getWarehouses()
            .then(result => {
                this.warehouses_list = result['list'];
            });
    }

    getDetailsByItem(): void {
        this.stock_availibility_service.getDetailsByItem(this.item, this.category)
            .then(result => {
                this.prod_list = result['list'];
            });
    }

    getArticlesLotInfos(article: any, i: number): void {
        this.detailsMouvementWarehouse(article, 'true');
        if (this.tmp === i) {
            this.hide_lot_infos = true;
            this.tmp = -1;
            this.hide_lot_infos = false;
        } else {
            this.item = article.internal_code;
            this.getDetailsByItem();
            this.tmp = i;
        }
    }

    detailsMouvementWarehouse(prod: any, warehouses: any) {
        this.movement_list = [];
        var entrepot = '';
        if (this.category === undefined) {
            entrepot = warehouses;
        } else {
            entrepot = this.category;
        }
        this.stock_availibility_service.detailsMouvementWarehouse(prod.internal_code, entrepot)
            .then(response => {
                this.movement_list = response['list']['response'];
                this.total = response['list']['total'];
                this.date = response['list']['date'];
            });
        if (warehouses === 'true') {
            this.info_article = '(' + prod.name + ' - stocks disponibles : ' + prod.stock + ')';
        } else {
            this.info_article = '(' + warehouses + ' : ' + prod.name + ' - Stock disponible : ' + prod.stock + ')';
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/stock-availibility.component.ts